import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = ["data-molid", "data-idx"];
const _hoisted_2 = { key: 2 };
const _hoisted_3 = ["data-molid", "data-idx"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FilterInput = _resolveComponent("FilterInput");
    const _component_TitleBar = _resolveComponent("TitleBar");
    const _component_TreeView = _resolveComponent("TreeView", true);
    return (_openBlock(), _createElementBlock("div", {
        class: "tree-view-wrapper",
        ref: "scroller",
        onScrollPassive: _cache[1] || (_cache[1] =
            //@ts-ignore
            (...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
        onClick: _cache[2] || (_cache[2] = _withModifiers(
        //@ts-ignore
        (...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)), ["self"]))
    }, [
        (_ctx.allTreeDataFlattened.length > 0 && _ctx.depth === 0)
            ? (_openBlock(), _createBlock(_component_FilterInput, {
                key: 0,
                list: _ctx.allTreeDataFlattened,
                extractTextToFilterFunc: _ctx.extractTextToFilterFunc,
                onOnFilter: _ctx.onFilter,
                mb: "1",
                modelValue: _ctx.filterStr,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filterStr) = $event))
            }, null, 8, ["list", "extractTextToFilterFunc", "onOnFilter", "modelValue"]))
            : _createCommentVNode("", true),
        (_ctx.isVirtualizable)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                style: _normalizeStyle(_ctx.sizerStyles)
            }, [
                _createElementVNode("div", {
                    style: _normalizeStyle(_ctx.virtualListStyles)
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleNodes, (treeDatum, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: treeDatum.id,
                            "data-molid": treeDatum.id,
                            style: _normalizeStyle(_ctx.styleToUse),
                            "data-idx": idx + _ctx.startIndex
                        }, [
                            _createVNode(_component_TitleBar, {
                                treeDatum: treeDatum,
                                depth: _ctx.depth,
                                treeData: _ctx.treeData,
                                filterStr: _ctx.filterStr
                            }, null, 8, ["treeDatum", "depth", "treeData", "filterStr"])
                        ], 12, _hoisted_1));
                    }), 128))
                ], 4)
            ], 4))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLocalTreeData, (treeDatum, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: treeDatum.id,
                        "data-molid": treeDatum.id,
                        style: _normalizeStyle(_ctx.styleToUse),
                        "data-idx": idx
                    }, [
                        _createVNode(_component_TitleBar, {
                            treeDatum: treeDatum,
                            depth: _ctx.depth,
                            treeData: _ctx.treeData,
                            filterStr: _ctx.filterStr
                        }, null, 8, ["treeDatum", "depth", "treeData", "filterStr"]),
                        (treeDatum?.nodes && treeDatum?.treeExpanded && _ctx.filteredTreeNodes === null)
                            ? (_openBlock(), _createBlock(_component_TreeView, {
                                key: 0,
                                treeData: treeDatum?.nodes,
                                depth: _ctx.depth + 1,
                                styleToUse: _ctx.indentStyle,
                                ref_for: true,
                                ref: treeDatum?.id
                            }, null, 8, ["treeData", "depth", "styleToUse"]))
                            : _createCommentVNode("", true)
                    ], 12, _hoisted_3));
                }), 128))
            ]))
    ], 544));
}
